import { useNavigate } from 'react-router'

import { ErrorScreen } from './ErrorScreen'

/**
 * Екран «Відсутній доступ» (`SPEC-014` §2.4) — сторінка, куди людину привела
 * пряма адреса, а не меню (`SPEC-003` §2.3: маршрут вирівняно з меню).
 *
 * Підключений як `templateError403` у `CrudResourceConfig`: без нього ядро на
 * `accessFn → false` не малювало нічого — порожній екран читався як зламаний
 * застосунок. Малюється всередині каркаса (меню й шапка лишаються), тож
 * людина бачить, де вона, і повертається звичним шляхом. Тексти й картинка —
 * легасі (`Error403.jsx:7-15`); ядровий `Error403` («Доступ заборонено»,
 * «Назад») не використовуємо.
 */
export const AccessDenied = () => {
    const navigate = useNavigate()

    return (
        <ErrorScreen
            image="/assets/errors/error403.svg"
            title="Відсутній доступ"
            subTitle="Недостатньо прав, щоб відкрити цю сторінку."
            onHome={() => navigate('/')}
        />
    )
}
